import { Provider } from '@angular/core';

import {
  BASE_SITE_CONTEXT_ID,
  BaseSiteService,
  ContextServiceMap,
  CURRENCY_CONTEXT_ID,
  CurrencyService,
  LANGUAGE_CONTEXT_ID,
  LanguageService
} from '@spartacus/core';

import { MEASUREMENT_SYSTEM_CONTEXT_ID } from '../constants/measurement-system-context-id.constant';
import { DpMeasurementSystemService } from '../facade/measurement-system.service';

export const contextServiceMapProvider: Provider = {
  provide: ContextServiceMap,
  useFactory: () => ({
    [LANGUAGE_CONTEXT_ID]: LanguageService,
    [CURRENCY_CONTEXT_ID]: CurrencyService,
    [BASE_SITE_CONTEXT_ID]: BaseSiteService,
    [MEASUREMENT_SYSTEM_CONTEXT_ID]: DpMeasurementSystemService
  })
};
